<template>
  <div class="activity">
    <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd" size="small">新建</el-button>
    <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="!del" @click="handleDel">删除</el-button>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="cfflowitemName" label="流程" >
      </el-table-column>
      <el-table-column prop="cfflowdealName" label="交易" >
      </el-table-column>
      <el-table-column prop="cfflowworkName" label="活动" >
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="70">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click.native.stop="handleDel(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialog-drag
      title="新增审批活动"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="审批活动" prop="cfflowworkId">
          <!-- <el-select v-model="ruleForm.cfflowworkId" placeholder="请选择审批活动" style="width:100%">
            <el-option v-for="(item, index) in postList" :key="index" :label="item.resourceName" :value="item.ofrResourceId"></el-option>
          </el-select> -->
          <treeselect v-model="ruleForm.cfflowworkId" :options="options" :normalizer="normalizer" placeholder="请选择审批活动" :disable-branch-nodes="true" :flat="true"/>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import qs from 'qs'
import DictTag from '@/components/DictTag.vue'
import {mapState} from 'vuex'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  export default {
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      })
    },
    components: {
      DictTag,
      Treeselect
    },
    props: {
      cfappId: [String, Number],
    },
    data() {
      return {
        // cfappId: this.$route.params.cfAppId,
        del: false,
        tableData: [],
        loading: false,
        dialogFormVisible: false,
        ruleForm: {
          cfflowworkId: null,
          cfappId: null,
        },
        rules: {
          cfflowworkId: [{ required: true, message: "请选择审批活动", trigger: "submit" }]
        },
        isLoading: false,
        postList: [],
        ids: [],
        options: []
      }
    },
    created () {
      this.ruleForm.cfappId = this.cfappId
      this.getData();
      this.getList()
    },
    methods: {
      getData() {
        this.$http.get(url.getCflowItemTree).then(res => {
          if(res.data.code == 200) {
            this.options = res.data.data
            this.options.forEach(process => {
              process.isDisabled = true
              if(process.children) {
                process.children.forEach(deal => {
                  deal.isDisabled = true
                })
              }
            })
          }
        })
      },
      /** 转换数据结构 */
      normalizer(node) {
        // this.$nextTick(() => {
          if (node.children == null || node.children.length == 0) {
            delete node.children;
          }
          // console.log(node.typeLevel);
          // return {
          //   id: node.cbOwhId,
          //   label: node.name,
          //   children: node.children
          // };
        // })
      },
      getList() {
        this.$http.get(url.getCfAppWorkList, {params: {cfappId: this.cfappId}}).then(res => {
          if(res.data.code == 200) {
            this.tableData = res.data.data
          }
        })
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            // this.ruleForm.maxnum = Number(this.ruleForm.maxnum )
            // 新增审批步骤
            this.$http.post(url.addCfAppWork, qs.stringify(this.ruleForm)).then(res => {
              // console.log(res);
              this.isLoading = false
              if(res.data.code === 200) {
                this.$message.success(res.data.msg);
                this.dialogFormVisible = false;
                this.getList()
              }
            })
          } else {
            return false;
          }
        });
      },
      handleAdd() {
        this.dialogFormVisible = true
        this.$nextTick(() => {
        // 清除表单校验效果
          this.$refs.ruleForm.clearValidate();
        })
        // 初始化表单内容
        this.ruleForm.cfflowworkId =null
      },
      handleDel(row) {
        // console.log(row);
        let cfAppWorkIds = row.cfAppWorkId || this.ids.toString()
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.removeCfAppWork, qs.stringify({cfAppWorkIds})).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getList()
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.cfAppWorkId)
        this.del = rows.length >= 1
      }
    },
  }
</script>

<style lang="scss" scoped>
.activity {
  .el-table {
    margin-top: 16px;
  }
}
</style>
